import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { formatCurrencyNumber, formatIntlUSD } from "../../chunks/utils.js";
import './fundraising.dashboard.css';const causeList = [
  {
    causeId: "5bc5db5c-40a8-4306-a6a9-1592cbc8ab50",
    causeName: "Red Wagon for St. Jude"
  },
  {
    causeId: "a2997e00-1e0c-4eb9-b435-1ff5b2ab759b",
    causeName: "Art Supplies for St. Jude"
  },
  {
    causeId: "e98114f6-fe8c-41db-bf7f-c977e6d07803",
    causeName: "Family Meal Card for St. Jude"
  },
  {
    causeId: "0845427c-5979-4bd4-a223-2673d36ae25a",
    causeName: "No More Chemo Party"
  },
  {
    causeId: "b94bc9f8-7bf9-46a1-a683-a905b6ad0fcc",
    causeName: "2/3 Share of Chemotherapy Treatment"
  },
  {
    causeId: "b9d0d014-42f4-49b4-a230-8c4eb27db13e",
    causeName: "New Toy for Hospital Play Areas"
  },
  {
    causeId: "b12bef25-e5f3-4a27-b8b1-8271df77ffaf",
    causeName: "Share of Bone Marrow Treatment"
  }
];
const FundraisingDashboard = ({
  donations = [],
  polls = [],
  milestones = [],
  rewards = [],
  goalAmount = 1,
  currentAmount = 0,
  minimumDonationAmount = 0,
  minimumHighlightAmount = 0,
  donorAmount = 3,
  isEvent = false,
  overallGoalAmount,
  overallCurrentAmount,
  isLoadingMilestones = false
}) => {
  let remaining;
  let overallRemaining;
  let progress;
  let overallProgress;
  if (overallCurrentAmount > overallGoalAmount) {
    overallProgress = 100;
    overallRemaining = 0;
  } else {
    overallProgress = Math.round(
      100 * (overallCurrentAmount / overallGoalAmount)
    );
    overallRemaining = overallGoalAmount - overallCurrentAmount;
    if (Number.isNaN(overallProgress)) overallProgress = 0;
    if (Number.isNaN(overallRemaining)) overallRemaining = 100;
  }
  if (currentAmount > goalAmount) {
    progress = 100;
    remaining = 0;
  } else {
    progress = Math.round(100 * (currentAmount / goalAmount));
    remaining = goalAmount - currentAmount;
    if (Number.isNaN(progress)) progress = 0;
    if (Number.isNaN(remaining)) remaining = 100;
  }
  const rewardList = useMemo(
    () => (rewards ?? []).map((reward) => {
      return {
        rewardId: reward.id,
        rewardName: reward.name
      };
    }),
    [rewards]
  );
  const pollList = useMemo(
    () => (polls ?? []).map((poll) => {
      return {
        pollsID: poll.id,
        pollsName: poll.name,
        pollsOption: poll.options.map((option) => {
          return {
            optionId: option.id,
            optionName: option.name
          };
        })
      };
    }),
    [polls]
  );
  const pollOptionsList = useMemo(
    () => pollList.reduce(
      (optionsArray, poll) => {
        optionsArray.push(...poll.pollsOption);
        return optionsArray;
      },
      []
    ),
    [pollList]
  );
  const optionsList = useMemo(
    () => pollOptionsList.flatMap((x) => x),
    [pollOptionsList]
  );
  const donorList = useMemo(
    () => (donations ?? []).map((donation) => {
      return {
        id: donation.id,
        name: donation.donor_name,
        amount: formatCurrencyNumber(Number(donation.amount.value)),
        amountHighlight: Number(donation.amount.value),
        comment: donation.donor_comment,
        causeID: donation.cause_id,
        rewardClaimed: donation.reward_claims !== null && donation.reward_claims !== void 0 ? donation.reward_claims.map((claimed) => {
          const rewardItem = rewardList.find(
            (r) => r.rewardId === claimed.reward_id
          );
          return {
            reward_id: claimed.reward_id,
            reward_name: rewardItem ? rewardItem.rewardName : null
          };
        }) : [],
        pollID: donation.poll_option_id
      };
    }),
    [donations, rewardList]
  );
  const donorResult = useMemo(
    () => donorList.map((result) => {
      const causeItem = causeList.find(
        (causeName) => causeName.causeId === result.causeID
      );
      const optionItem = optionsList.find(
        (optionName) => optionName.optionId === result.pollID
      );
      return {
        ...result,
        causeName: causeItem ? causeItem.causeName : null,
        optionName: optionItem ? optionItem.optionName : null
      };
    }),
    [donorList, optionsList]
  );
  const milestonesList = useMemo(
    () => (milestones ?? []).sort(
      (a, b) => Number(a.amount.value) - Number(b.amount.value)
    ),
    [milestones]
  );
  const donorFilter = useMemo(
    () => donorResult.filter(
      (donation) => Number(donation.amount) >= minimumDonationAmount
    ),
    [donorResult, minimumDonationAmount]
  );
  let milestonesBlock;
  if ((milestones == null ? void 0 : milestones.length) > 0 && !isLoadingMilestones) {
    milestonesBlock = /* @__PURE__ */ jsxs("div", { className: "dashboard-milestones h-full", children: [
      /* @__PURE__ */ jsx("p", { className: "header", children: "Next Milestone" }),
      milestonesList.map((milestone) => /* @__PURE__ */ jsxs(
        "div",
        {
          className: `
                        ${Number(
            100 * (Number(milestone.amount.value) / Number(goalAmount))
          ) > progress ? "dashboard-milestones__text higher" : "dashboard-milestones__text lower"}
                      `,
          children: [
            /* @__PURE__ */ jsxs("p", { className: "m_info2", children: [
              /* @__PURE__ */ jsx("span", { className: "mamount", children: formatIntlUSD(
                Math.round(
                  parseFloat(milestone.amount.value) - currentAmount
                ) > 0 ? Math.round(
                  parseFloat(milestone.amount.value) - currentAmount
                ) : 0
              ) }),
              /* @__PURE__ */ jsxs("span", { className: "mtotal", children: [
                "away from ",
                formatIntlUSD(Number(milestone.amount.value))
              ] })
            ] }),
            /* @__PURE__ */ jsx("p", { className: "m_info1", children: milestone.name })
          ]
        },
        milestone.id
      )),
      /* @__PURE__ */ jsx("div", { className: "dashboard-milestones__text higher", children: /* @__PURE__ */ jsx("p", { children: "All milestones have been successfully completed" }) })
    ] });
  } else if (isLoadingMilestones) {
    milestonesBlock = /* @__PURE__ */ jsxs("div", { className: "dashboard-milestones h-full", children: [
      /* @__PURE__ */ jsx("p", { className: "header", children: "Milestones" }),
      /* @__PURE__ */ jsx("div", { className: "dashboard-milestones__none", children: /* @__PURE__ */ jsx("p", { children: "Loading..." }) })
    ] });
  } else if (milestones.length === 0) {
    milestonesBlock = /* @__PURE__ */ jsxs("div", { className: "dashboard-milestones h-full", children: [
      /* @__PURE__ */ jsx("p", { className: "header", children: "Next Milestone" }),
      /* @__PURE__ */ jsx("div", { className: "dashboard-milestones__none", children: /* @__PURE__ */ jsx("p", { children: "There are no active milestones for this campaign" }) })
    ] });
  }
  return /* @__PURE__ */ jsx("div", { className: "dashboard-wrapper overflow-hidden h-full", children: /* @__PURE__ */ jsx("div", { className: "dashboard-overlay overflow-auto h-full", children: /* @__PURE__ */ jsxs("section", { className: "p-2 grid grid-cols-1 md:grid-cols-3   gap-4 md:grid-rows-12 gutters  content w-full h-full", children: [
    /* @__PURE__ */ jsx("div", { className: "col-span-1 md:col-span-3 row-span-1 ", children: /* @__PURE__ */ jsxs("div", { className: "flex therm h-full items-center justify-center", children: [
      /* @__PURE__ */ jsx("div", { className: "mr-4 therm_raised text-white font-bold text-3xl ml-2", children: formatIntlUSD(currentAmount) }),
      /* @__PURE__ */ jsx("div", { className: "flex-grow therm_therm mb-1.5", children: /* @__PURE__ */ jsx("div", { className: "therm_therm__wrapper", children: /* @__PURE__ */ jsx(
        "div",
        {
          className: "therm_therm__inner",
          style: {
            width: `${progress}%`
          }
        }
      ) }) }),
      /* @__PURE__ */ jsx("div", { className: "ml-4 therm_goal text-white font-bold text-3xl mr-2", children: formatIntlUSD(goalAmount) })
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: "col-span-1 row-span-5 raised flex flex-col items-center justify-center", children: [
      /* @__PURE__ */ jsx("p", { className: "header", children: "To Fundraising Goal" }),
      /* @__PURE__ */ jsxs("div", { className: `circle p${progress}`, children: [
        /* @__PURE__ */ jsxs("span", { children: [
          progress,
          "%"
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "slice", children: [
          /* @__PURE__ */ jsx("div", { className: "bar" }),
          /* @__PURE__ */ jsx("div", { className: "fill" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "header", children: [
        formatIntlUSD(remaining),
        /* @__PURE__ */ jsx("br", {}),
        " Remaining"
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "col-span-1 row-span-5 raised flex flex-col items-center justify-center", children: [
      /* @__PURE__ */ jsx("p", { className: "header", children: "To Event Goal" }),
      /* @__PURE__ */ jsxs("div", { className: `circle p${overallProgress}`, children: [
        /* @__PURE__ */ jsxs("span", { children: [
          overallProgress,
          "%"
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "slice", children: [
          /* @__PURE__ */ jsx("div", { className: "bar" }),
          /* @__PURE__ */ jsx("div", { className: "fill" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "header", children: [
        formatIntlUSD(overallRemaining),
        /* @__PURE__ */ jsx("br", {}),
        " Remaining"
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "col-span-1 min-h-[500px] md:row-span-12  overflow-hidden", children: /* @__PURE__ */ jsxs("div", { className: isEvent ? "donors event" : "donors", children: [
      /* @__PURE__ */ jsx("p", { className: "header", children: minimumDonationAmount > 0 ? `Recent Donations over $${minimumDonationAmount}` : "Recent Donations" }),
      /* @__PURE__ */ jsx("ul", { className: "overflow-y-auto", children: donorFilter.slice(0, Number(donorAmount)).map((donor) => /* @__PURE__ */ jsxs(
        "li",
        {
          className: donor.amountHighlight >= minimumHighlightAmount ? "tier5" : "normal",
          children: [
            /* @__PURE__ */ jsx("strong", { children: donor.name }),
            " ",
            /* @__PURE__ */ jsxs("span", { className: "donation-amount", children: [
              "$",
              donor.amount
            ] }),
            " ",
            donor.comment ? /* @__PURE__ */ jsxs("p", { className: "donors_comment", children: [
              /* @__PURE__ */ jsx("strong", { children: "Comment: " }),
              donor.comment
            ] }) : null,
            donor.rewardClaimed.length > 0 && /* @__PURE__ */ jsx("div", { children: (donor.rewardClaimed ?? []).map((claimed) => {
              return /* @__PURE__ */ jsx("div", { children: claimed.reward_name === null ? "" : /* @__PURE__ */ jsx("p", { className: "donors_reward", children: /* @__PURE__ */ jsxs("em", { children: [
                /* @__PURE__ */ jsx("strong", { children: "Reward: " }),
                claimed.reward_name
              ] }) }) }, claimed.reward_id);
            }) }),
            donor.causeName ? /* @__PURE__ */ jsx("p", { className: "donors_reward", children: /* @__PURE__ */ jsxs("em", { children: [
              /* @__PURE__ */ jsx("strong", { children: "Reward: " }),
              donor.causeName
            ] }) }) : null,
            donor.optionName ? /* @__PURE__ */ jsx("p", { className: "donors_poll", children: /* @__PURE__ */ jsxs("em", { children: [
              /* @__PURE__ */ jsx("strong", { children: "Poll: " }),
              donor.optionName
            ] }) }) : null
          ]
        },
        donor.id
      )) })
    ] }) }),
    /* @__PURE__ */ jsx("div", { className: "md:col-span-2 row-span-7", children: milestonesBlock })
  ] }) }) });
};
function getFundraisingDashboardConfigFromURL(url) {
  const config = new URLSearchParams(url.search);
  const minimumDonationAmount = Number.parseInt(
    config.get("minDonation") ?? "5",
    10
  );
  const minimumHighlightAmount = Number.parseInt(
    config.get("highlight") ?? "5",
    10
  );
  const donorAmount = Number.parseInt(config.get("donorMin") ?? "10", 10);
  const ccamMode = config.get("ccam") !== null;
  const showAllDonations = (config.get("showAllDonations") ?? "yes") === "yes";
  const isEvent = (config.get("isEvent") ?? "no") === "yes";
  return {
    showAllDonations,
    ccamMode,
    minimumDonationAmount,
    minimumHighlightAmount,
    donorAmount,
    isEvent
  };
}
export {
  FundraisingDashboard,
  getFundraisingDashboardConfigFromURL
};
//# sourceMappingURL=fundraising.dashboard.js.map
